import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 16s-1.5-2-4-2-4 2-4 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7.5 8 10 9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m14 9 2.5-1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 10h0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 10h0", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Angry";
const Angry = memo(themed(Icon));
export {
  Angry
};
//# sourceMappingURL=angry.js.map
